import { CorrespondenceCompanyDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CorrespondenceCompanyService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCorrespondenceCompany(): Observable<CorrespondenceCompanyDto[]> {
    return this.http.get<CorrespondenceCompanyDto[]>(
      this.url + 'correspondence-company'
    );
  }

  createCorrespondenceCompany(
    data: CorrespondenceCompanyDto[]
  ): Observable<CorrespondenceCompanyDto[]> {
    return this.http.post<CorrespondenceCompanyDto[]>(
      this.url + 'correspondence-company',
      data
    );
  }
  getSingleCorrespondenceCompany(id: string): Observable<any> {
    return this.http.get(this.url + 'correspondence-company/' + id);
  }

  updateCorrespondenceCompany(
    data: CorrespondenceCompanyDto[]
  ): Observable<CorrespondenceCompanyDto[]> {
    return this.http.post<CorrespondenceCompanyDto[]>(
      this.url + 'correspondence-company/update',
      data
    );
  }

  deleteCorrespondenceCompany(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('correspondence-company', ids.join(', '));
    return this.http.delete(this.url + 'correspondence-company', httpOptions);
  }
}
